module.exports = __webpack_public_path__ + "5e6a87d7855a5a87230ed74598773af9.svg";